import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

function Ubac({ users, fallback, children }) {
  const user = useSelector(
    ({
      app: {
        profile: { email },
      },
    }) => email
  );
  return users.includes(user) ? children : fallback;
}

Ubac.propTypes = {
  users: PropTypes.arrayOf(PropTypes.string).isRequired,
  fallback: PropTypes.node,
};

Ubac.defaultProps = {
  fallback: null,
};

export default Ubac;
